module.exports = __webpack_public_path__ + "img/2020.54d41a60.png";